module.exports = __webpack_public_path__ + "img/21-image-1-1@2x.9d9ba997.png";